import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import CategoryGrid from './components/CategoryGrid';
import SEOArticlesSection from './components/SEOArticlesSection';
import WhyChooseUs from './components/WhyChooseUs';
import ComparisonTable from './components/ComparisonTable';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <TrustBar />
        <CategoryGrid />
        <SEOArticlesSection />
        <WhyChooseUs />
        <ComparisonTable />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}